import { SkeletonBar, TextPassage } from '@petsmart-ui/sparky';

import { LegacyIcon, LegacyIconName } from '@libs/common-next';

import { useTreatPoints } from '../model';

import './TreatPoints.scss';

export type TreatPointsProps = {
    sku: string;
    price: number;
    quantity: number;
    guestTreatPoints?: number;
};

export const TreatPoints = (props: TreatPointsProps) => {
    const { treatPoints, isPending } = useTreatPoints(props);

    const renderLoader = () => (
        <span className="treat-points__loader-wrapper" data-testid="pdp-treat-points-loader">
            <SkeletonBar size="sm" className="treat-points__loader" />
        </span>
    );

    return (
        <div className="treat-points" data-testid="pdp-treat-points">
            <LegacyIcon name={LegacyIconName.TREATS_NEW} size={16} />
            <TextPassage size="sm">
                <span>Estimated {isPending ? renderLoader() : treatPoints} points earned</span>
            </TextPassage>
        </div>
    );
};
